// extracted by mini-css-extract-plugin
export default {"cancelButton":"ConfirmDialog_cancelButton__B5Eck","deleteButton":"ConfirmDialog_deleteButton__SsGup"};